import { MessageConfigTypes } from 'src/features/components/editComponentPage/forms/cod/CODForm.interface';

export const COD_COMPONENT_CONFIG = {
  codSettings: {
    globalSetting: {
      font: 'Speedee_W_Rg',
      color: '',
      background: 'black',
      featureFlags: {
        originalPriceCalculation: true,
      },
    },
    codSetting: {
      layoutConfig: {
        height: '',
        width: '',
        heightOffset: '160px',
      },
      header: {
        order: {
          font: 'Speedee_W_Bd',
          color: 'white',
          fontSize: '48px',
          lineHeight: '48px',
          letterSpacing: '-0.5px',
          label: 'Your Order',
          border: '4px solid #FFBC0D',
        },
        pagination: {
          font: 'Speedee_W_Rg',
          color: 'white',
          fontSize: '23px',
          lineHeight: '28px',
          letterSpacing: '-0.5px',
          enable: true,
        },
      },
      topMessage: {
        message:
          "<p style='font-size:23px;letter-spacing:-0.5px;'>Ask to “Round-Up” your total for an RMHC donation</p>",
        color: '#D6D6D6',
        boxPadding: {
          paddingLeft: '30px',
          paddingRight: '30px',
          paddingTop: '30px',
          paddingBottom: '30px',
        },
        hideRmhcMessage: false,
      },
      total: {
        total: {
          label: 'Total',
          font: 'Speedee_W_Bd',
          fontSize: '40px',
          lineHeight: '40px',
          letterSpacing: '-0.5px',
          color: 'white',
        },
        save: {
          label: 'You Saved',
          font: '',
          fontSize: '28px',
          lineHeight: '28px',
          letterSpacing: '-0.5px',
          color: '#D6D6D6',
        },
        tax: {
          label: 'Tax',
          font: '',
          fontSize: '28px',
          lineHeight: '28px',
          letterSpacing: '-0.5px',
          color: '#D6D6D6',
        },
        boxPadding: {
          paddingBottom: '9px',
        },
      },
      body: {
        font: 'Speedee_W_Bd',
        color: '',
        denseView: false,
        styleConfig: {
          product: {
            font: 'Speedee_W_Bd',
            color: 'white',
            fontSize: '28px',
            lineHeight: '28px',
            letterSpacing: '-0.5px',
          },
          subProduct: {
            font: 'Speedee_W_Rg',
            color: 'white',
            fontSize: '27px',
            lineHeight: '28px',
            letterSpacing: '-0.5px',
          },
          discounts: {
            label: {
              border: '1px solid red',
              font: 'Speedee_W_Bd',
              backgroundColor: 'white',
              color: 'black',
              fontSize: '28px',
              lineHeight: '28px',
              letterSpacing: '-0.5px',
            },
            price: {
              border: '1px solid red',
              font: 'Speedee_W_Rg',
              color: 'white',
              fontSize: '28px',
              lineHeight: '28px',
              letterSpacing: '-0.5px',
            },
          },
        },
        promoLabel: 'PROMO APPLIED',
        orderSelection: {
          backgroundColor: '',
          color: '',
        },
        discount: {
          dealUsed: {
            label: 'deal',
          },
          reward: {
            label: 'reward',
          },
        },
      },
      footer: {
        knownCustomer: {
          linkedPayment: [
            {
              top: 0,
              left: 0,
              zIndex: 10,
              enabledTypeKey: MessageConfigTypes.ICON_AND_TEXT,
              image: 'Icon- known user.png',
              iconAndText: {
                icon: 'mobile-payment.png',
                label: 'Paying with app',
                font: '',
                fontSize: '23px',
                lineHeight: '25px',
                letterSpacing: '-0.5px',
                color: 'white',
              },
              wrapperStyle: {
                background: 'transparent',
                border: 'none',
                borderRadius: '8px',
                padding: '5px',
              },
            },
          ],
          unlinkedPayment: [
            {
              top: 0,
              left: 0,
              zIndex: 1,
              enabledTypeKey: MessageConfigTypes.ICON_AND_TEXT,
              image: 'Icon- unknown user dark mode.png',
              iconAndText: {
                icon: 'no-payment.png',
                label:
                  'No more wallet shuffling.<br />Link your card in the app.',
                font: '',
                fontSize: '23px',
                lineHeight: '25px',
                letterSpacing: '-0.5px',
                color: '#D6D6D6',
              },
            },
          ],
        },
        unknownCustomer: [
          {
            top: 0,
            left: 0,
            zIndex: 1,
            enabledTypeKey: MessageConfigTypes.ICON_AND_TEXT,
            image: 'Icon- unknown user dark mode.png',
            iconAndText: {
              icon: 'no-payment.png',
              label:
                'No more wallet shuffling.<br />Link your card in the app.',
              font: '',
              fontSize: '23px',
              lineHeight: '25px',
              letterSpacing: '-0.5px',
              color: '#D6D6D6',
            },
          },
        ],
      },
    },
    confirmSetting: {
      header: {
        review: {
          banner: {
            images: {
              largeImage: {
                background: 'cod-demo-banner-large.png',
              },
              smallImage: {
                background: 'cod-demo-banner-small.png',
              },
            },
            font: '',
            color: '',
            showBannerImage: true,
            active: true,
            backgroundColor: 'red',
            alignment: 'left',
            top: '20px',
            left: '20px',
            label:
              "<strong><span style='color:blue;font-size:60px;'>hello world</strong>",
          },
          font: '',
          color: '',
          label: 'Controleer uw bestelling hieronder',
        },
        order: {
          font: '',
          color: '',
          label: 'Uw bestelling',
          items: {
            singleLabel: 'item',
            manyLabel: 'items',
          },
        },
        loyalty: {
          color: '#000',
          label: '',
          icon: '',
        },
      },
      topMessage: {
        message:
          '<h1><strong style="font-size:48px;line-height:48px;font-family:Speedee_W_Bd;letter-spacing:0px">Let’s check to make sure everything’s right</strong></h1>',
        color: '#292929',
        boxPadding: {
          paddingLeft: '56px',
          paddingRight: '56px',
          paddingTop: '30px',
          paddingBottom: '30px',
        },
        hideRmhcMessage: false,
      },
      total: {
        background: 'linear-gradient(270deg, #FFBC0D 0%, #FFDF1E 100%)',
        boxPadding: {
          paddingBottom: '30px',
        },
        total: {
          label: 'Total',
          font: 'Speedee_W_Bd',
          fontSize: '80px',
          lineHeight: '80px',
          letterSpacing: '-0.5px',
          color: '#292929',
        },
        title: {
          label: 'Your Order',
          font: 'Speedee_W_Bd',
          fontSize: '80px',
          lineHeight: '80px',
          letterSpacing: '-0.5px',
          color: '#292929',
        },
        save: {
          label: 'You Saved',
          font: 'Speedee_W_Bd',
          fontSize: '48px',
          lineHeight: '48px',
          letterSpacing: '-0.5px',
          color: '#4D4D4D',
        },
        tax: {
          label: 'Tax',
          font: 'Speedee_W_Bd',
          fontSize: '48px',
          lineHeight: '48px',
          letterSpacing: '-0.5px',
          color: '#4D4D4D',
        },
        donate: {
          label: 'You Donated',
          font: 'Speedee_W_Bd',
          fontSize: '48px',
          lineHeight: '48px',
          letterSpacing: '-0.5px',
          color: '#4D4D4D',
        },
      },
      body: {
        font: '',
        color: '',
        styleConfig: {
          product: {
            font: 'Speedee_W_Bd',
            color: '#292929',
            fontSize: '40px',
            lineHeight: '40px',
            letterSpacing: '-0.5px',
          },
          subProduct: {
            font: 'Speedee_W_Rg',
            color: '#292929',
            fontSize: '40px',
            lineHeight: '40px',
            letterSpacing: '-0.5px',
          },
          discounts: {
            label: {
              border: '1px solid red',
              font: 'Speedee_W_Bd',
              backgroundColor: 'white',
              color: 'black',
              fontSize: '40px',
              lineHeight: '40px',
              letterSpacing: '-0.71px',
            },
            price: {
              border: '1px solid red',
              font: 'Speedee_W_Rg',
              color: 'black',
              fontSize: '40px',
              lineHeight: '40px',
              letterSpacing: '-0.5px',
            },
          },
        },
        discount: {
          dealUsed: {
            label: 'deal',
          },
          reward: {
            label: 'reward',
          },
        },
      },
      footer: {
        background: 'white',
        knownCustomer: {
          linkedPayment: [
            {
              top: 10,
              left: 10,
              enabledTypeKey: MessageConfigTypes.ICON_AND_TEXT,
              image: 'Icon- known user.png',
              iconAndText: {
                icon: 'mobile-payment.png',
                label: 'Paying with app',
                font: 'Speedee_W_Bd',
                fontSize: '23px',
                lineHeight: '23px',
                letterSpacing: '-0.5px',
                color: 'black',
              },
              wrapperStyle: {
                background: 'white',
                border: '3px solid #E6E6E6',
                borderRadius: '8px',
                padding: '5px',
              },
            },
          ],
          unlinkedPayment: [
            {
              top: 0,
              left: 0,
              zIndex: 1,
              enabledTypeKey: MessageConfigTypes.ICON_AND_TEXT,
              image: 'Icon- unknown user dark mode.png',
              iconAndText: {
                icon: 'no-payment.png',
                label:
                  'No more wallet shuffling.<br />Link your card in the app.',
                font: 'Speedee_W_Bd',
                fontSize: '23px',
                lineHeight: '23px',
                letterSpacing: '-0.5px',
                color: '#2D2D2D',
              },
            },
          ],
        },
        unknownCustomer: [
          {
            top: 0,
            left: 0,
            zIndex: 1,
            enabledTypeKey: MessageConfigTypes.ICON_AND_TEXT,
            image: 'Icon- unknown user dark mode.png',
            iconAndText: {
              icon: 'no-payment.png',
              label:
                'No more wallet shuffling.<br />Link your card in the app.',
              font: 'Speedee_W_Bd',
              fontSize: '23px',
              lineHeight: '23px',
              letterSpacing: '-0.5px',
              color: '#2D2D2D',
            },
          },
        ],
      },
    },
  },
};
